import { Link } from "react-router-dom";

import classes from "./css/Footer.module.css";

const Footer = () => {
  return (
    <>
      <main className={classes.main}>
        <div className={classes.name}>
          <h4>NICASIO ANZELMO</h4>
        </div>

        <content className={classes.content}>
          <div className={classes.info}>
            <div>
              <h4>Contatti</h4>
              <p>Cell: 338.5976727</p>
              <p>Email: info@nicasioanzelmo.com</p>
            </div>
            <div className={classes.scriptwave}>
              <p>Powered by&nbsp;</p>
              <p style={{ color: "white" }}>Scriptwave</p>
            </div>
          </div>

          <div className={classes.links}>
            <ul>
              <h4>Esplora</h4>
              <Link
                to="/"
                className={({ isActive }) =>
                  isActive ? classes.active : undefined
                }
                end
              >
                Home
              </Link>
              <Link
                to="/about"
                className={({ isActive }) =>
                  isActive ? classes.active : undefined
                }
              >
                Su di Me
              </Link>
              <Link
                to="/shows"
                className={({ isActive }) =>
                  isActive ? classes.active : undefined
                }
              >
                Spettacoli
              </Link>
              <Link
                to="/archive"
                className={({ isActive }) =>
                  isActive ? classes.active : undefined
                }
              >
                Archivio
              </Link>
              <Link
                to="/dionisiache"
                className={({ isActive }) =>
                  isActive ? classes.active : undefined
                }
                end
              >
                Dionisiache
              </Link>
            </ul>
          </div>
        </content>

        <Link
          to="/privacy-policy"
          className={({ isActive }) => (isActive ? classes.active : undefined)}
          end
        >
          Privacy Policy
        </Link>
        <p>2023 TUTTI I DIRITTI RISERVATI</p>
      </main>
    </>
  );
};

export default Footer;
